/* global mixpanel */
import formatDate from 'mixpanel/formatDate'
function mapHistoryDetailToMixpanel (d) {
  return {
    'Item Name': d.item_name,
    'Variant': d.item_variant_name,
    'Qty in Stock': d.beginning_stock,
    'Qty Order': d.quantity,
    'Unit Cost': d.price,
    'Total Cost': d.quantity * d.price
  }
}

function mapIngredientHistoryDetailToMixpanel (d) {
  return {
    'Ingredient Name': d.ingredient_name,
    'Qty in Stock': d.beginning_stock,
    'Qty Order': d.quantity,
    'Unit Cost': d.unit_price,
    'Total Cost': d.quantity * d.unit_price
  }
}

export function inventoryPOStart ({outletIds, startDate, endDate, namespace}) {
  mixpanel.track('Inventory PO Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
    'Current Inventory Filter': namespace
  })
}

export function inventoryPOChangeFilter ({outletIds, startDate, endDate, namespace}) {
  mixpanel.track('Inventory PO Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
    'Current Inventory Filter': namespace
  })
}

export function inventoryPOCreate ({fulfilled, supplier, outlet, namespace, items}) {
  const data = {
    'Current Inventory Filter': namespace,
    'Outlet Name': outlet.name,
    'Supplier Name': supplier.name
  }
  if (namespace === 'items') {
    data['List of Items'] = items.map(d => ({
      'Ingredient Name': d.item_name,
      'Qty in Stock': d.instock,
      'Qty Order': d.order,
      'Unit Cost': d.unitcost,
      'Total Cost': d.order * d.unitcost
    }))
  } else {
    data['List of Ingredients'] = items.map(d => ({
      'Item Name': d.item_name,
      'Variant': d.item_var_name,
      'Qty in Stock': d.instock,
      'Qty Order': d.order,
      'Unit Cost': d.unitcost,
      'Total Cost': d.order * d.unitcost
    }))
  }
  if (fulfilled) {
    mixpanel.track('Inventory PO Create and Fulfill', data)
  } else {
    mixpanel.track('Inventory PO Create', data)
  }
}

export function inventoryPOSelect ({purchaseOrder}) {
  const namespace = purchaseOrder.hasOwnProperty('history_details') ? 'items' : 'ingredients'
  const mixpanelData = {
    'Supplier Name': purchaseOrder.supplier_name,
    'Supplier Email': purchaseOrder.supplier_email,
    'Supplier Phone': purchaseOrder.supplier_phone,
    'PO Number': purchaseOrder.order_no,
    'PO Created At': formatDate(purchaseOrder.created_at),
    'PO Created By': `${purchaseOrder.creator.first_name} ${purchaseOrder.creator.last_name}`,
    'Email': purchaseOrder.creator.email,
    'Outlet Name': purchaseOrder.outlet.name,
    'Phone': purchaseOrder.outlet.phone_number,
    'Address': purchaseOrder.outlet.address
  }
  if (namespace === 'items') {
    mixpanelData['List of Items'] = purchaseOrder.history_details.map(mapHistoryDetailToMixpanel)
  } else {
    mixpanelData['List of Ingredients'] = purchaseOrder.ingredient_history_details.map(mapIngredientHistoryDetailToMixpanel)
  }
  mixpanel.track('Inventory Select PO', mixpanelData)
}

export function inventoryPOUpdateStatus ({purchaseOrder, status}) {
  const namespace = purchaseOrder.hasOwnProperty('history_details') ? 'items' : 'ingredients'
  const mixpanelData = {
    'Outlet Name': purchaseOrder.outlet.name,
    'Supplier Name': purchaseOrder.supplier_name,
    'Current Inventory Filter': namespace
  }
  let eventName
  if (status === 'Fulfilled') {
    eventName = 'Inventory PO Mark Fulfilled'
  } else if (status === 'Cancelled') {
    eventName = 'Inventory PO Cancel Order'
  }
  if (namespace === 'items') {
    mixpanelData['List of Items'] = purchaseOrder.history_details.map(mapHistoryDetailToMixpanel)
  } else {
    mixpanelData['List of Ingredients'] = purchaseOrder.ingredient_history_details.map(mapIngredientHistoryDetailToMixpanel)
  }

  // if eventname is null, do not track
  if (eventName) {
    mixpanel.track(eventName, mixpanelData)
  }
}

export function inventoryPOExport ({outletIds, startDate, endDate, namespace}) {
  mixpanel.track('Inventory PO Export', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
    'Current Inventory Filter': namespace
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/inventory/purchaseOrders.js